// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3M1eE","btnRed":"styles_btnRed__13ezS","form":"styles_form__uQ3JP","title":"styles_title__tSxpT","content":"styles_content__YoCM6"};